export const emptyOnNull = (value) => value ?? '';

export const nullOnEmpty = (value) => value || null;

export const handleNullish = (value, defaultValue) =>
    value === '' || value == null ? defaultValue : value;

export const stripHTMLTags = (str) => str.replaceAll(/<[^>]*>?/gm, '');
